import React from "react";
import { useTranslation } from "react-i18next";

import "./style.scss";
import ResultSummaryContent from "./ResultSummary";

function SummaryContent({ userName, summary, keywords }) {
  const { t } = useTranslation();

  return (
    <div className=" w-100">
      <div className="summary-text">
        {t("Generated by:")}
        {userName}
      </div>
      <div style={{ marginTop: "16px" }}>
        <ResultSummaryContent summary={summary} keywords={keywords} />
      </div>
    </div>
  );
}

export default SummaryContent;
